<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Master Akun</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              <a href="#">Master</a>
            </div>
            <div class="breadcrumb-item">
              Akun
            </div>
          </div>
        </div>

        <div class="section-body">
          <div class="card">
            <div class="card-header">
              <h4 class="d-inline">
                Master Data Akun
              </h4>
              <div class="card-header-action">
                <b-button
                  v-if="pageType === 'index' && $store.getters.getAuthService.currentRole.nama_role != 'Operator Desa'"
                  class="btn btn-primary"
                  @click="modalTambahAkun"
                >
                  <i class="fa fa-plus mr-2" /> Tambah Akun
                </b-button>
                <button
                  v-if="pageType === 'index'"
                  id="btnRefresh"
                  class="btn btn-primary"
                  title="Refresh"
                  @click="loadPostsData"
                >
                  <i class="fa fa-sync" />
                </button>
                <button
                  v-if="pageType === 'add' || pageType === 'edit'"
                  class="btn btn-danger"
                  title="Kembali"
                  @click="pageType = 'index'"
                >
                  <i class="fa fa-chevron-left pr-2" />Kembali
                </button>
              </div>
            </div>
            <!-- tabel -->
            <div
              v-if="pageType === 'index'"
              class="card-body"
              style="overflow:hidden"
            >
              <div class="row">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for="">Tipe Pengguna</label>
                    <v-select
                      v-model="filter.role"
                      :options="optionRole" 
                      :clearable="false"
                    />

                    <!-- <input id="filterMultiRole" type="checkbox" v-model="filter.is_multi_role" class="mt-3"> <label for="filterMultiRole">Tampilkan Multi Role</label> -->
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label for="">Status Akun</label>
                    <v-select
                      v-model="filter.is_disabled"
                      :options="[{id: 0, label:'Aktif'}, {id:1, label:'Non-Aktif'}]"
                      :clearable="false"
                    />
                  </div>
                </div>
                <div class="col-lg-5">
                  <div class="form-group">
                    <label for="">Kecamatan</label>
                    <div class="row">
                      <div class="col-md-6">
                        <v-select
                          v-model="filter.id_kecamatan"
                          :options="optionKecamatan"
                          label="nama_kecamatan"
                          :loading="loadingKecamatan"
                          :disabled="$store.getters.getAuthService.currentRole.nama_role === 'Operator Desa' || $store.getters.getAuthService.currentRole.nama_role === 'Kepala Desa' || $store.getters.getAuthService.currentRole.nama_role === 'Operator Kecamatan'"
                          :clearable="false"
                        />
                      </div>
                      <div class="col-md-6">
                        <v-select
                          v-model="filter.id_desa"
                          :options="optionDesa"
                          label="nama_desa"
                          :loading="loadingDesa"
                          :disabled="$store.getters.getAuthService.currentRole.nama_role === 'Operator Desa' || $store.getters.getAuthService.currentRole.nama_role === 'Kepala Desa'"
                          :clearable="false"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label class="text-white">s</label><br>
                    <button
                      class="btn btn-primary"
                      @click="loadPostsData"
                    >
                      <i class="fa fa-filter mr-2" />Filter
                    </button>
                  </div>
                </div>
              </div>
              <hr>
              <AkunTable
                :items="items" 
                :fields="fields" 
                :meta="meta" 
                :edit-url="'/a/b'"
                :loading="tableLoading"
                :aksi="'kelolaakun'"
                @per_page="handlePerPage" 
                @pagination="handlePagination" 
                @search="handleSearch" 
                @sort="handleSort"
                @delete="handleDelete"
                @editAkun="editAkun"
                @resetPasswordAkun="resetPasswordAkun"
                @disableAkun="disableAkun"
                @enableAkun="enableAkun"
              />
            </div>

            <!-- form add -->
            <div
              v-else-if="pageType === 'add'"
              class="card-body"
            >
              <div class="alert alert-primary alert-has-icon mb-5">
                <div class="alert-icon">
                  <i class="far fa-lightbulb" />
                </div>
                <div class="alert-body">
                  <div class="alert-title">
                    Informasi
                  </div>
                  <p>
                    Akun <b>SiPeDuLi Jembrana</b> memerlukan NIK penduduk sebagai verifikasi.
                    Jika data tidak ada pada kolom pencarian, silahkan tambah penduduk terlebih dahulu.
                  </p>
                </div>
              </div>
                            
              <div v-if="!pendudukShow">
                <h6 class="text-primary">
                  Pilih Penduduk
                </h6>
                <hr>
                <SearchPenduduk @pilihPenduduk="pilihPenduduk" />
              </div>
							
              <div
                v-if="pendudukShow"
                class="row"
              >
                <!-- identitas penduduk -->
                <div class="col-lg-6 mb-5">
                  <div class="row">
                    <div class="col-6">
                      <h6 class="text-primary">
                        Penduduk
                      </h6>
                    </div>
                    <div class="col-6 text-right">
                      <button
                        class="btn btn-danger btn-sm"
                        style="padding-left: 15px; padding-right: 15px; border-radius: 50px"
                        @click="pendudukShow = null"
                      >
                        <i class="fa fa-times mr-2" />Ubah Penduduk
                      </button>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-md-3">
                      <div style="background:#eee;height:200px;text-align:center">
                        <i
                          class="fa fa-user"
                          style="font-size: 3rem;margin-top:70px"
                        />
                      </div>
                    </div>
                    <div class="col-md-9">
                      <table class="table table-sm">
                        <tr>
                          <td>Nama Penduduk</td>
                          <td>:</td>
                          <td>{{ pendudukShow.nama_lengkap }}</td>
                        </tr>
                        <tr>
                          <td>NIK</td>
                          <td>:</td>
                          <td>{{ pendudukShow.nik }}</td>
                        </tr>
                        <tr>
                          <td>Nomor KK</td>
                          <td>:</td>
                          <td>{{ pendudukShow.no_kk }}</td>
                        </tr>
                        <tr>
                          <td>Tempat Tanggal Lahir</td>
                          <td>:</td>
                          <td>
                            {{ pendudukShow.tempat_lahir }},
                            {{
                              new Date(pendudukShow.tanggal_lahir).toLocaleDateString('id-ID', {year: 'numeric', month: 'long', day: 'numeric'})
                            }}
                          </td>
                        </tr>
                        
                        <tr>
                          <td>Alamat</td>
                          <td>:</td>
                          <td>{{ pendudukShow.alamat }}</td>
                        </tr>
                        <tr>
                          <td colspan="2" />
                          <td>{{ pendudukShow.desa.nama_desa }}, {{ pendudukShow.desa.kecamatan.nama_kecamatan }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- akun penduduk -->
                <div class="col-lg-6">
                  <h6 class="text-primary">
                    Akun
                  </h6>
                  <hr>
                  <form
                    action=""
                    method="POST"
                    @submit="submitAddAkun"
                  >
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="email">Email aktif</label>
                          <input
                            id="email"
                            type="email"
                            class="form-control" 
                            name="email"
                            required
                            v-model="formAkun.email"
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="no_hp">Nomor HP aktif</label>
                          <input
                            id="no_hp"
                            type="number"
                            class="form-control" 
                            name="no_hp"
                            required
                            v-model="formAkun.no_hp"
                          >
                        </div>
                      </div>
                    </div>
                    
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="username">Username</label>
                          <input
                            id="username"
                            type="text"
                            class="form-control" 
                            name="username"
                            required
                            v-model="formAkun.username"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="password">Password</label>
                          <div class="input-group mb-3">
                            <input
                              :type="(!isShowPassword) ? 'password' : 'text'"
                              class="form-control"
                              tabindex="2"
                              required
                              v-model="formAkun.password"
                            >
                            <div class="input-group-append">
                              <button
                                class="btn btn-primary"
                                type="button"
                                @click="isShowPassword = !isShowPassword"
                              >
                                <i
                                  class="fa"
                                  :class="(!isShowPassword) ? 'fa-eye' : 'fa-eye-slash'"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="c_password">Masukkan ulang password</label>
                          <div class="input-group mb-3">
                            <input
                              :type="(!isShowPasswordC) ? 'password' : 'text'"
                              class="form-control"
                              tabindex="2"
                              required
                              v-model="formAkun.c_password"
                            >
                            <div class="input-group-append">
                              <button
                                class="btn btn-primary"
                                type="button"
                                @click="isShowPasswordC = !isShowPasswordC"
                              >
                                <i
                                  class="fa"
                                  :class="(!isShowPasswordC) ? 'fa-eye' : 'fa-eye-slash'"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                        <p style="font-weight: 600; color: #34395e; font-size: 12px; letter-spacing: .5px; margin-bottom: 0px">
                          Pilih Hak Akses
                        </p>
                        <div
                          v-for="(f, i) in optionRole"
                          :key="'role-' + i"
                          class="form-check"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'role-' + i"
                            :value="f"
                            v-model="formAkun.role"
                          >
                          <label
                            class="form-check-label"
                            :for="'role-' + i"
                          >{{ f }}</label>
                        </div>
                      </div>
                    </div>

                    <!-- jika operator desa, pilih di desa mana dia tugas -->
                    <div
                      v-if="formAkun.role.includes('Operator Desa') || formAkun.role.includes('Kepala Desa')"
                      class="row"
                    >
                      <div class="col-12">
                        <div class="form-group">
                          <label for="">Desa Tempat Tugas</label>
                          <div class="row">
                            <div class="col-lg-6">
                              <v-select
                                id="role"
                                v-model="formAkun.id_kecamatan" 
                                label="nama_kecamatan"
                                :clearable="false"
                                :options="optionKecamatan"
                              />
                            </div>
                            <div class="col-lg-6">
                              <v-select
                                id="role"
                                v-model="formAkun.id_desa" 
                                label="nama_desa"
                                :clearable="false"
                                :loading="loadingDesa"
                                :options="optionDesaModal"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- jika operator dukcapil kecamatan, pilih kecamatan mana -->
                    <div
                      v-if="formAkun.role.includes('Operator Dukcapil Kecamatan')"
                      class="row"
                    >
                      <div class="col-12">
                        <div class="form-group">
                          <label for="">Kecamatan tempat operator dukcapil bertugas</label>
                          <v-select
                            id="role"
                            multiple
                            v-model="formAkun.kecamatan" 
                            label="nama_kecamatan"
                            :options="optionKecamatan"
                          />
                          <small>Ketik nama kecamatan, lalu pilih</small>
                        </div>
                      </div>
                    </div>

                    <div>
                      <button
                        id="btnAddAkun"
                        class="btn btn-primary"
                        type="submit"
                        title="Simpan"
                      >
                        <i class="fa fa-check mr-2" />Simpan 
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- form edit -->
            <div
              v-else-if="pageType === 'edit'"
              class="card-body"
            >
              <div class="row">
                <!-- penduduk -->
                <div class="col-lg-6">
                  <h6 class="mt-3 text-primary">
                    Penduduk
                  </h6>
                  <hr>
                  <div class="row">
                    <div class="col-md-3">
                      <div style="background:#eee;height:200px;text-align:center">
                        <i
                          class="fa fa-user"
                          style="font-size: 3rem;margin-top:70px"
                        />
                      </div>
                    </div>
                    <div class="col-md-9">
                      <table
                        class="table table-sm"
                        v-if="pendudukShow"
                      >
                        <tr>
                          <td>Nama Penduduk</td>
                          <td>:</td>
                          <td>{{ pendudukShow.nama_lengkap }}</td>
                        </tr>
                        <tr>
                          <td>NIK</td>
                          <td>:</td>
                          <td>{{ pendudukShow.nik }}</td>
                        </tr>
                        <tr>
                          <td>Nomor KK</td>
                          <td>:</td>
                          <td>{{ pendudukShow.no_kk }}</td>
                        </tr>
                        <tr>
                          <td>Tempat Tanggal Lahir</td>
                          <td>:</td>
                          <td>
                            {{ pendudukShow.tempat_lahir }},
                            {{
                              new Date(pendudukShow.tanggal_lahir).toLocaleDateString('id-ID', {year: 'numeric', month: 'long', day: 'numeric'})
                            }}
                          </td>
                        </tr>
                        
                        <tr>
                          <td>Alamat</td>
                          <td>:</td>
                          <td>{{ pendudukShow.alamat }}</td>
                        </tr>
                        <tr>
                          <td colspan="2" />
                          <td>{{ pendudukShow.desa.nama_desa }}, {{ pendudukShow.desa.kecamatan.nama_kecamatan }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <h6 class="mt-3 text-primary">
                    Akun
                  </h6>
                  <hr>
                  <div class="alert alert-primary alert-has-icon">
                    <div class="alert-icon">
                      <i class="far fa-lightbulb" />
                    </div>
                    <div class="alert-body">
                      <div class="alert-title">
                        Informasi
                      </div>
                      Data yang dapat diedit adalah email, username dan nomor hp.
                      Password hanya dapat diubah oleh pemilik akun, sedangkan admin hanya dapat membantu untuk reset password.
                    </div>
                  </div>
                  <form
                    action=""
                    method="POST"
                    @submit="submitEditAkun"
                  >
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="email_edit">Email aktif</label>
                          <input
                            id="email_edit"
                            type="email"
                            class="form-control" 
                            name="email"
                            required
                            v-model="formAkun.email"
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="no_hp_edit">Nomor HP aktif</label>
                          <input
                            id="no_hp_edit"
                            type="number"
                            class="form-control" 
                            name="no_hp"
                            required
                            v-model="formAkun.no_hp"
                          >
                        </div>
                      </div>
                    </div>
                    
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="username_edit">Username</label>
                          <input
                            id="username_edit"
                            type="text"
                            class="form-control" 
                            name="username"
                            required
                            v-model="formAkun.username"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                        <p style="font-weight: 600; color: #34395e; font-size: 12px; letter-spacing: .5px; margin-bottom: 0px">
                          Pilih Hak Akses
                        </p>
                        <div
                          v-for="(f, i) in optionRole"
                          :key="'role-' + i"
                          class="form-check"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'role-' + i"
                            :value="f"
                            v-model="formAkun.role"
                          >
                          <label
                            class="form-check-label"
                            :for="'role-' + i"
                          >{{ f }}</label>
                        </div>
                      </div>
                    </div>

                    <!-- jika operator desa, pilih di desa mana dia tugas -->
                    <div
                      v-if="formAkun.role.includes('Operator Desa') || formAkun.role.includes('Kepala Desa')"
                      class="row"
                    >
                      <div class="col-12">
                        <div class="form-group">
                          <label for="">Desa Tempat Tugas</label>
                          <div class="row">
                            <div class="col-lg-6">
                              <v-select
                                id="role"
                                v-model="formAkun.id_kecamatan" 
                                label="nama_kecamatan"
                                :clearable="false"
                                :options="optionKecamatan"
                              />
                            </div>
                            <div class="col-lg-6">
                              <v-select
                                id="role"
                                v-model="formAkun.id_desa" 
                                label="nama_desa"
                                :clearable="false"
                                :loading="loadingDesa"
                                :options="optionDesaModal"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- jika operator dukcapil kecamatan, pilih kecamatan mana -->
                    <div
                      v-if="formAkun.role.includes('Operator Dukcapil Kecamatan')"
                      class="row"
                    >
                      <div class="col-12">
                        <div class="form-group">
                          <label for="">Kecamatan tempat operator dukcapil bertugas</label>
                          <v-select
                            id="role"
                            multiple
                            v-model="formAkun.kecamatan" 
                            label="nama_kecamatan"
                            :options="optionKecamatan"
                          />
                          <small>Ketik nama kecamatan, lalu pilih</small>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        id="btnEditAkun"
                        class="btn btn-primary"
                        type="submit"
                        title="Simpan"
                      >
                        <i class="fa fa-check mr-2" />Simpan 
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<style scoped>

</style>

<script>
import LayoutAdmin from './../layouts/Admin.vue'
import NProgress from 'nprogress'
import swal from 'sweetalert'
import AkunTable from './../../components/table/AkunTable.vue'
import SearchPenduduk from './../../components/global/SearchPenduduk.vue'

export default {
  name: 'App',
  data() {
    return {
      pageType: 'index',
      fields: [
        { key: 'no' },
        { key: 'nama_pemilik', label: 'Nama', sortable: true },
        { key: 'desa', sortable: true },
        { key: 'email', sortable: true },
        { key: 'username', sortable: true },
        { key: 'no_hp', sortable: true },
        { key: 'is_aktif', label: 'Verifikasi OTP', sortable: true },
        { key: 'last_login', label: 'Terakhir Login', sortable: true },
        { key: 'created_at', label: 'Tanggal Daftar', sortable: true },
        { key: 'actions', sortable: false },
      ],
      filter: {
        role: 'Operator Desa',
        is_disabled: { id: 0, label: 'Aktif' },
        is_multi_role: false,
        id_kecamatan: { id_kecamatan: 0, nama_kecamatan: 'SEMUA KECAMATAN' },
        id_desa: { id_desa: 0, nama_desa: 'SEMUA DESA' },
      },
      items: [],
      meta: {},
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'created_at',
      sortByDesc: false,
      tableLoading: true,

      pendudukShow: null,


      namaSPenduduk: '',
      formAkun: {
        nik: null,
        no_kk: null,
        no_hp: null,
        email: null,
        username: null,
        password: null,
        c_password: null,
        role: [],
        kecamatan: [],
        id_kecamatan: '',
        id_desa: ''
      },
      isShowPassword: false,
      isShowPasswordC: false,
      idAkunEdit: '',
      optionKecamatan: [{
        id_kecamatan: 0,
        nama_kecamatan: 'Semua'
      }],
      optionDesa: [{
        id_desa: 0,
        nama_desa: 'SEMUA DESA'
      }],
      optionDesaModal: [{
        id_desa: 0,
        nama_desa: 'SEMUA DESA'
      }],
      loadingKecamatan: true,
      loadingDesa: false,
      loadingDesaModal: false,
    }
  },
  computed: {
    optionRole() {


      let role = this.$store.getters.getAuthService.currentRole.nama_role

      let option = null

      if (role === 'Operator Desa') {
        option = ['Penduduk']
      } else if (role === 'Kepala Desa') {
        option = ['Penduduk', 'Operator Desa']
      } else if (role === 'Operator Kecamatan') {
        option = ['Operator Desa', 'Kepala Desa', 'Operator Kecamatan']
      } else if (role === 'Operator Dukcapil') {
        option = ['Operator Desa', 'Kepala Desa', 'Operator Kecamatan', 'Operator Dukcapil', 'Operator Dukcapil Kecamatan']
      } else if (role === 'Operator Dukcapil Kecamatan') {
        option = ['Operator Desa', 'Kepala Desa', 'Operator Kecamatan', 'Operator Dukcapil', 'Operator Dukcapil Kecamatan']
      } else if (role === 'Admin Laksita' || role === 'Admin Jembrana') {
        option = ['Penduduk', 'Operator Desa', 'Kepala Desa', 'Operator Kecamatan', 'Operator Dukcapil', 'Operator Dukcapil Kecamatan', 'Admin Laksita', 'Admin Jembrana', 'Rumah Sakit']
      }

      return option

    },
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    }
  },
  components: {
    LayoutAdmin, AkunTable, SearchPenduduk
  },
  created() {
    this.setDefaultFilterPengguna()
  },
  methods: {
    //METHOD INI AKAN MENGHANDLE REQUEST DATA KE API
    loadPostsData() {
      this.tableLoading = true
      NProgress.start()
      let button = document.querySelector('#btnRefresh')
      let buttonHtml = ''
      if (button) {
        buttonHtml = button.innerHTML
        button.setAttribute('disabled', true)
        button.innerHTML = '<i class="fa fa-spin fa-sync"></i>'
      }

      let current_page = this.search == '' ? this.current_page : 1

      let role = this.$store.getters.getAuthService.currentRole.nama_role

      let dispatchAkun = 'getAllAkun'

      if (role === 'Operator Desa' || role === 'Kepala Desa') {
        dispatchAkun = 'getAkunByDesa'
      } else if (role === 'Operator Kecamatan') {
        dispatchAkun = 'getAkunByKecamatan'
      } else if (role === 'Operator Dukcapil' || role === 'Operator Dukcapil Kecamatan' || role === 'Admin Laksita' || role === 'Admin Jembrana') {
        dispatchAkun = 'getAllAkun'
      }


      let data = {
        page: current_page,
        per_page: this.per_page,
        q: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC' : 'ASC',
        role: this.filter.role,
        is_disabled: this.filter.is_disabled.id,
        is_multi_role: this.filter.is_multi_role,
      }

      if (role === 'Operator Kecamatan') {
        if (this.filter.id_desa.id_desa != 0) {
          data.id_desa = this.filter.id_desa.id_desa
        }
      } else if (role === 'Operator Dukcapil' || role === 'Operator Dukcapil Kecamatan' || role === 'Admin Laksita' || role === 'Admin Jembrana') {
        if (this.filter.id_desa.id_desa != 0) {
          data.id_desa = this.filter.id_desa.id_desa
        }
        if (this.filter.id_kecamatan.id_kecamatan != 0) {
          data.id_kecamatan = this.filter.id_kecamatan.id_kecamatan
        }
      }

      this.$store.dispatch(dispatchAkun, data).then((response) => {
        // PARSE DATE
        let date = ''
        let created_at = ''
        let last_login = ''
        // let created_at_hours = ''
        response.data.data.data.forEach(e => {
          e.nama_pemilik = (e.penduduk) ? e.penduduk.nama_lengkap : '-'
          date = new Date(e.created_at)
          created_at = date.toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
          created_at += ' ' + date.toLocaleTimeString('it-IT')
          e.created_at = created_at

          // last login
          if (e.last_login) {
            date = new Date(e.last_login)
            last_login = date.toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
            last_login += ' ' + date.toLocaleTimeString('it-IT')
            e.last_login = last_login
          }
        })
        //JIKA RESPONSENYA DITERIMA
        let getData = response.data.data
        this.items = getData.data //MAKA ASSIGN DATA POSTINGAN KE DALAM VARIABLE ITEMS
        //DAN ASSIGN INFORMASI LAINNYA KE DALAM VARIABLE META
        this.meta = {
          total: getData.total,
          current_page: getData.current_page,
          per_page: getData.per_page,
          from: getData.from,
          to: getData.to
        }
        if (button) {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml
        }

        NProgress.done()
        this.tableLoading = false
      })




      //LAKUKAN REQUEST KE API UNTUK MENGAMBIL DATA POSTINGAN
      // let token = this.$store.getters.getAuthService.token
      // axios.get(`/api/akun/get`, {
      //     //KIRIMKAN PARAMETER BERUPA PAGE YANG SEDANG DILOAD, PENCARIAN, LOAD PERPAGE DAN SORTING.
      //     params: {
      //         page: current_page,
      //         per_page: this.per_page,
      //         q: this.search,
      //         sortby: this.sortBy,
      //         sortbydesc: this.sortByDesc ? 'DESC':'ASC'
      //     },
      //     headers: { Authorization: `Bearer ${token}` }
      // })
    },
    //JIKA ADA EMIT TERKAIT LOAD PERPAGE, MAKA FUNGSI INI AKAN DIJALANKAN
    handlePerPage(val) {
      this.per_page = val //SET PER_PAGE DENGAN VALUE YANG DIKIRIM DARI EMIT
      this.loadPostsData() //DAN REQUEST DATA BARU KE SERVER
    },
    //JIKA ADA EMIT PAGINATION YANG DIKIRIM, MAKA FUNGSI INI AKAN DIEKSEKUSI
    handlePagination(val) {
      this.current_page = val //SET CURRENT PAGE YANG AKTIF
      this.loadPostsData()
    },
    //JIKA ADA DATA PENCARIAN
    handleSearch(val) {
      this.search = val //SET VALUE PENCARIAN KE VARIABLE SEARCH
      this.loadPostsData() //REQUEST DATA BARU
    },
    //JIKA ADA EMIT SORT
    handleSort(val) {
      //MAKA SET SORT-NYA
      this.sortBy = val.sortBy
      this.sortByDesc = val.sortDesc

      this.loadPostsData() //DAN LOAD DATA BARU BERDASARKAN SORT
    },
    handleDelete(val) {
      // console.log(val)
    },
    submitAddAkun(e) {
      e.preventDefault()
      if (this.formAkun.nik === '' || this.formAkun.no_kk === '') {
        swal({
          title: "Gagal",
          text: "Pilih penduduk untuk akun yang akan dibuat.",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }


      if (this.formAkun.email === '' || this.formAkun.no_hp === '' || this.formAkun.username === '' || this.formAkun.password === '' || this.formAkun.c_password === '' || this.formAkun.role.length === 0) {
        swal({
          title: "Gagal",
          text: "Isi semua form",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }

      // password
      if(this.formAkun.password !== this.formAkun.c_password){
        swal({
            title: "Kesalahan",
            text: "Password yang dimasukkan tidak sama",
            icon: "error",
            buttons: "Ok"
        })
        return false
      }
      if(this.formAkun.password.length < 8){
        swal({
            title: "Kesalahan",
            text: "Password minimal terdiri dari 8 huruf",
            icon: "error",
            buttons: "Ok"
        })
        return false
      }
      if(!/[a-z]/.test(this.formAkun.password) || !/[A-Z]/.test(this.formAkun.password) || !/\d/.test(this.formAkun.password)){
        swal({
            title: "Kesalahan",
            text: "Password harus terdiri dari huruf besar, huruf kecil, dan angka",
            icon: "error",
            buttons: "Ok"
        })
        return false
      }

      // no_hp
			if(this.formAkun.no_hp.length < 10 || this.formAkun.no_hp.length > 15){
				swal({
            title: "Kesalahan",
            text: "Nomor HP Tidak Valid",
            icon: "error",
            buttons: "Ok"
        })
        return false
			}

      // username
      if(this.formAkun.username.length < 8){
        swal({
            title: "Kesalahan",
            text: "Username minimal terdiri dari 8 huruf",
            icon: "error",
            buttons: "Ok"
        })
        return false
			}
			if(this.formAkun.username.includes(' ')){
        swal({
            title: "Kesalahan",
            text: "Username tidak boleh berisi spasi",
            icon: "error",
            buttons: "Ok"
        })
        return false
			}



      let role = this.$store.getters.getAuthService.currentRole.nama_role


      if (role === 'Operator Desa' && this.formAkun.role.includes('Operator Desa')) {
        // jika operator desa input operator baru
        // kasi alert apakah ingin mendisable operator yang lama?
        // kalau iya, gak jadi insert
        swal({
          title: "Informasi",
          text: "Anda akan menambah operator desa baru. Silahkan non-aktifkan akun operator desa jika sudah tidak dipakai.",
          icon: "warning",
          buttons: {
            cancel: "Kembali",
            ok: {
              text: "Lanjutkan Buat Akun",
              value: "ok",
            },
          }
        }).then(val => {
          if (val === 'ok') {
            this.register()
          } else {
            return false
          }
        })

      } else if (role === 'Operator Kecamatan' && this.formAkun.role.includes('Operator Kecamatan')) {
        // jika operator desa input operator baru
        // kasi alert apakah ingin mendisable operator yang lama?
        // kalau iya, gak jadi insert
        swal({
          title: "Informasi",
          text: "Anda akan menambah operator kecamatan baru. Silahkan non-aktifkan akun operator kecamatan jika sudah tidak dipakai.",
          icon: "warning",
          buttons: {
            cancel: "Kembali",
            ok: {
              text: "Lanjutkan Buat Akun",
              value: "ok",
            },
          }
        }).then(val => {
          if (val === 'ok') {
            this.register()
          } else {
            return false
          }
        })
      } else if (role === 'Operator Dukcapil' || role === 'Operator Dukcapil Kecamatan') {
        if (this.formAkun.role.includes('Operator Dukcapil') || this.formAkun.role.includes('Operator Dukcapil Kecamatan')) {
          // jika operator dukcapil kecamatan
          // cek apakah formAkun.kecamatan sudah diisi
          if (this.formAkun.kecamatan.length === 0) {
            swal({
              title: "Kesalahan",
              text: 'Pilih kecamatan tempat bertugas',
              icon: 'error',
              buttons: 'Ok'
            })
            return false
          }

          // jika operator desa input operator baru
          // kasi alert apakah ingin mendisable operator yang lama?
          // kalau iya, gak jadi insert
          swal({
            title: "Informasi",
            text: "Anda akan menambah operator dukcapil baru. Silahkan non-aktifkan akun operator dukcapil jika sudah tidak dipakai.",
            icon: "warning",
            buttons: {
              cancel: "Kembali",
              ok: {
                text: "Lanjutkan Buat Akun",
                value: "ok",
              },
            }
          }).then(val => {
            if (val === 'ok') {
              this.register()
            } else {
              return false
            }
          })
        } else {
          this.register()
        }
      } else {
        this.register()
      }
    },
    register() {
      // let test = true
      // if(test){
      //     swal({
      //         title: "Berhasil",
      //         text: "Berhasil membuat akun",
      //         icon: "success",
      //         buttons: "Ok"
      //     })
      //     return false
      // }

      if (this.formAkun.role.includes('Operator Desa') || this.formAkun.role.includes('Kepala Desa')) {
        if (this.formAkun.id_desa.id_desa == 0) {
          swal({
            title: "Kesalahan",
            text: "Pilih Desa Tempat Bertugas",
            icon: "error",
            buttons: "Ok"
          })
          return false
        }
      }

      let button = document.querySelector('#btnAddAkun')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'

      let formData = new FormData()
      formData.append('nik', this.formAkun.nik)
      formData.append('no_kk', this.formAkun.no_kk)
      formData.append('no_hp', this.formAkun.no_hp)
      formData.append('email', this.formAkun.email)
      formData.append('username', this.formAkun.username)
      formData.append('password', this.formAkun.password)
      formData.append('c_password', this.formAkun.c_password)
      formData.append('role', this.formAkun.role)


      // jika user op desa/kades, harus ada id_desanya
      if (this.formAkun.role.includes('Operator Desa') || this.formAkun.role.includes('Kepala Desa')) {
        formData.append('id_desa', this.formAkun.id_desa.id_desa)
      }

      // jika user op dukc kec, harus ada id kec
      if (this.formAkun.role.includes('Operator Dukcapil Kecamatan')) {
        let arrKec = []
        this.formAkun.kecamatan.forEach(e => {
          arrKec.push(e.id_kecamatan)
        })
        formData.append('kecamatan', arrKec)
      }


      this.$store.dispatch('registerPenduduk', formData).then((res) => {
        if (res.data.status) {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml

          swal({
            title: "Berhasil",
            text: "Berhasil membuat akun",
            icon: "success",
            buttons: "Ok"
          }).then(val => {
            this.pageType = 'index'
            this.loadPostsData()
          })
        } else {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml
          if (typeof (res.data.message) === 'object') {
            swal({
              title: "Gagal",
              text: "Periksa form kembali.",
              icon: "error",
              buttons: "Ok"
            })
          } else {
            swal({
              title: "Gagal",
              text: res.data.message,
              icon: "error",
              buttons: "Ok"
            })
          }
        }
      }).catch(err => {
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml

        // console.log(err.response)
        if (typeof (err.response.data.message) === 'object') {
          swal({
            title: "Gagal",
            text: "Pendaftaran gagal. Periksa form kembali.",
            icon: "error",
            buttons: "Ok"
          })
        } else {
          swal({
            title: "Gagal",
            text: err.response.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
    },
    modalTambahAkun() {
      // reset form
      this.pendudukShow = null
      this.formAkun = {
        nik: null,
        no_kk: null,
        email: null,
        username: null,
        no_hp: null,
        password: null,
        c_password: null,
        role: [],
        kecamatan: [],
        id_desa: '',
        id_kecamatan: '',
      }
      this.pageType = 'add'
    },
    pilihPenduduk(row) {
      if (this.$store.getters.getAuthService.currentRole.nama_role == 'Kepala Desa') {
        if (row.id_desa != this.$store.getters.getUser.id_desa) {
          swal({
            title: "Informasi",
            text: `${row.nama_lengkap} merupakan warga Desa ${row.desa.nama_desa}.
                                Sedangkan anda merupakan Kepala Desa ${this.$store.getters.getDesaUser.nama_desa}.
                                Abaikan pesan ini jika ingin menambahkan ${row.nama_lengkap} sebagai Operator Desa ${this.$store.getters.getDesaUser.nama_desa}.`,
            icon: "warning",
            buttons: "Ok"
          })
        }
      }

      this.pendudukShow = row
      this.namaSPenduduk = row.nama_lengkap
      this.formAkun.nik = row.nik
      this.formAkun.no_kk = row.no_kk
    },
    editAkun(data) {
      // console.log(data)
      this.pendudukShow = data.penduduk
      this.namaSPenduduk = data.penduduk.nama_lengkap
      this.formAkun.nik = data.penduduk.nik
      this.formAkun.no_kk = data.penduduk.no_kk
      this.idAkunEdit = data.id_user

      this.formAkun.email = data.email
      this.formAkun.username = data.username
      this.formAkun.no_hp = data.no_hp

      let hasOpDukKec = false
      let hasDes = false // jika op des / kades
      let arrRole = []
      data.role.forEach(e => {
        arrRole.push(e.nama_role)
        if (e.nama_role === 'Operator Dukcapil Kecamatan') {
          hasOpDukKec = true
        }
        if (e.nama_role === 'Operator Desa' || e.nama_role === 'Kepala Desa') {
          hasDes = true
        }
      })

      this.formAkun.role = arrRole

      // jika punya role desa
      if (hasDes) {
        this.formAkun.id_kecamatan = this.optionKecamatan.find(f => f.id_kecamatan === data.desa.id_kecamatan)

        setTimeout(() => {
          this.formAkun.id_desa = this.optionDesaModal.find(f => f.id_desa === data.id_desa)
        }, 2000)

        // data.user_op_duk_kec.forEach(e => {
        //     kecamatan.push(this.optionKecamatan.find(f => f.id_kecamatan === e.id_kecamatan))
        // })
        // this.formAkun.kecamatan = kecamatan
      }

      // jika punya role op duk kec, set kecamatan
      if (hasOpDukKec) {
        let kecamatan = []

        data.user_op_duk_kec.forEach(e => {
          kecamatan.push(this.optionKecamatan.find(f => f.id_kecamatan === e.id_kecamatan))
        })
        this.formAkun.kecamatan = kecamatan
      }
      this.pageType = 'edit'
    },
    submitEditAkun(e) {
      e.preventDefault()
      swal({
        title: "Konfirmasi",
        text: `Apakah anda yakin ingin mengedit akun ${this.pendudukShow.nama_lengkap}?`,
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Ya, Simpan",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          NProgress.start()
          let button = document.querySelector('#btnEditAkun')
          let buttonHtml = button.innerHTML

          button.setAttribute('disabled', true)
          button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'

          let formData = new FormData()
          formData.append('username', this.formAkun.username)
          formData.append('email', this.formAkun.email)
          formData.append('no_hp', this.formAkun.no_hp)
          formData.append('role', this.formAkun.role)

          // jika user op desa/kades, harus ada id_desanya
          if (this.formAkun.role.includes('Operator Desa') || this.formAkun.role.includes('Kepala Desa')) {
            formData.append('id_desa', this.formAkun.id_desa.id_desa)
          }

          // jika user op dukc kec, harus ada id kec
          if (this.formAkun.role.includes('Operator Dukcapil Kecamatan')) {
            let arrKec = []
            this.formAkun.kecamatan.forEach(e => {
              arrKec.push(e.id_kecamatan)
            })
            formData.append('kecamatan', arrKec)
          }


          this.$store.dispatch('updateAkun', { id: this.idAkunEdit, data: formData }).then((res) => {
            if (res.data.status) {
              swal({
                title: "Berhasil",
                text: res.data.message,
                icon: "success",
                buttons: "Ok"
              }).then(val => {
                this.pageType = 'index'
                this.loadPostsData()
              })
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }

            NProgress.done()
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
          }).catch(err => {
            // console.log(err)
            // console.log(err.response)
            NProgress.done()
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml

            if (typeof (err.response.data.message) === 'object') {
              swal({
                title: "Gagal",
                text: "Gagal mengedit akun, periksa form kembali",
                icon: "error",
                buttons: "Ok"
              })
            } else {
              swal({
                title: "Gagal",
                text: err.response.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
          })
        }
      })

    },
    resetPasswordAkun(data) {
      NProgress.start()
      let button = document.querySelector(`.btn-aksi-reset-password[data-id="${data.id_user}"]`)
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner"></i>'

      swal({
        title: "Konfirmasi",
        text: `Apakah anda yakin ingin mereset password akun ${data.penduduk.nama_lengkap}?`,
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Ya, Reset Password",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          this.$store.dispatch('resetPassword', data.id_user).then(res => {
            if (res.data.status) {
              const content = document.createElement('div')
              content.innerHTML = res.data.message
              swal({
                title: "Berhasil",
                content: content,
                icon: "success",
                buttons: "Tutup"
              })
              this.loadPostsData()
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
            NProgress.done()
          }).catch(err => {
            if (typeof (err.response.data.message) === 'object') {
              swal({
                title: "Gagal",
                text: "Gagal menghapus akun",
                icon: "error",
                buttons: "Ok"
              })
            } else {
              swal({
                title: "Gagal",
                text: err.response.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
            NProgress.done()
          })
        } else {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml
          NProgress.done()
        }
      })
    },
    disableAkun(data) {
      NProgress.start()
      // let button = e.target
      let button = document.querySelector(`.btn-aksi-disable[data-id="${data.id_user}"]`)
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner"></i>'

      swal({
        title: "Konfirmasi",
        text: `Apakah anda yakin ingin me-non-aktifkan akun ${data.penduduk.nama_lengkap}?`,
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Ya, Non-Aktifkan",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          this.$store.dispatch('disableAkun', data.id_user).then(res => {
            if (res.data.status) {
              swal({
                title: "Berhasil",
                text: res.data.message,
                icon: "success",
                buttons: "Ok"
              })
              // jika dia mendisable akun nya sendiri, logout, supaya tidak bisa login lagi
              if (this.$store.getters.getUser.id_user === data.id_user) {
                this.$store.dispatch('logoutUser').then((resp) => {
                  if (resp.data.status) {
                      localStorage.removeItem('authService')
                      localStorage.removeItem('fcmToken')
                      sessionStorage.clear()
                      window.location.href = '/login'
                  }
                }).catch((err) => {
                  swal({
                    title: "Gagal",
                    text: "Ada kesalahan teknis. Coba lagi nanti",
                    icon: "error",
                    buttons: "Ok"
                  })
                })
              }
              this.loadPostsData()
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
            NProgress.done()
          }).catch(err => {
            if (typeof (err.response.data.message) === 'object') {
              swal({
                title: "Gagal",
                text: "Gagal menghapus akun",
                icon: "error",
                buttons: "Ok"
              })
            } else {
              swal({
                title: "Gagal",
                text: err.response.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
            NProgress.done()
          })
        } else {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml
          NProgress.done()
        }
      })
    },
    enableAkun(data) {
      NProgress.start()
      let button = document.querySelector(`.btn-aksi-enable[data-id="${data.id_user}"]`)
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner"></i>'

      swal({
        title: "Konfirmasi",
        text: `Apakah anda yakin ingin memulihkan akun ${data.penduduk.nama_lengkap}?`,
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Ya, Pulihkan Akun",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          this.$store.dispatch('enableAkun', data.id_user).then(res => {
            if (res.data.status) {
              swal({
                title: "Berhasil",
                text: res.data.message,
                icon: "success",
                buttons: "Ok"
              })
              this.loadPostsData()
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
            NProgress.done()
          }).catch(err => {
            if (typeof (err.response.data.message) === 'object') {
              swal({
                title: "Gagal",
                text: "Gagal menghapus akun",
                icon: "error",
                buttons: "Ok"
              })
            } else {
              swal({
                title: "Gagal",
                text: err.response.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
            NProgress.done()
          })
        } else {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml
          NProgress.done()
        }
      })
    },
    // hapusAkun(data){
    //     NProgress.start()
    //     let button = e.target
    //     let buttonHtml = button.innerHTML

    //     button.setAttribute('disabled', true)
    //     button.innerHTML = '<i class="fa fa-spin fa-spinner"></i>'

    //     swal({
    //         title: "Konfirmasi",
    //         text: `Apakah anda yakin ingin menghapus akun ${data.penduduk.nama_lengkap}?`,
    //         icon: "warning",
    //         buttons: {
    //             cancel: "Batal",
    //             ok: {
    //                 text: "Ya, Hapus",
    //                 value: "ok",
    //             },
    //         }
    //     }).then( val => {
    //         if(val === 'ok'){
    //             this.$store.dispatch('hapusAkun', data.id_user).then( res =>{
    //                 if(res.data.status){
    //                     swal({
    //                         title: "Berhasil",
    //                         text: res.data.message,
    //                         icon: "success",
    //                         buttons: "Ok"
    //                     })
    //                     this.loadPostsData()
    //                 } else {
    //                     swal({
    //                         title: "Gagal",
    //                         text: res.data.message,
    //                         icon: "error",
    //                         buttons: "Ok"
    //                     })
    //                 }
    //                 button.removeAttribute('disabled')
    //                 button.innerHTML = buttonHtml
    //                 NProgress.done()
    //             }).catch(err => {
    //                 if(typeof(err.response.data.message) === 'object'){
    //                     swal({
    //                         title: "Gagal",
    //                         text: "Gagal menghapus akun",
    //                         icon: "error",
    //                         buttons: "Ok"
    //                     })
    //                 } else {
    //                     swal({
    //                         title: "Gagal",
    //                         text: err.response.data.message,
    //                         icon: "error",
    //                         buttons: "Ok"
    //                     })
    //                 }
    //                 button.removeAttribute('disabled')
    //                 button.innerHTML = buttonHtml
    //                 NProgress.done()
    //             })
    //         } else {
    //             button.removeAttribute('disabled')
    //             button.innerHTML = buttonHtml
    //             NProgress.done()
    //         }
    //     })
    // },
    loadKecamatan() {
      this.$store.dispatch('fetchKecamatan', { id_kabupaten: 274 }).then(res => {
        if (res.data.status) {
          let optKec = []
          optKec.push({
            id_kecamatan: 0,
            nama_kecamatan: 'SEMUA KECAMATAN'
          })
          res.data.data.forEach(e => {
            optKec.push(e)
          })
          this.optionKecamatan = optKec

          // select kecamatan sesuai role
          if (
            this.$store.getters.getAuthService.currentRole.nama_role === 'Operator Kecamatan' ||
            this.$store.getters.getAuthService.currentRole.nama_role === 'Operator Desa' ||
            this.$store.getters.getAuthService.currentRole.nama_role === 'Kepala Desa'
          ) {
            this.selectKecamatanByRole()
          }

          this.loadingKecamatan = false
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      }).catch(err => {
        // console.log(err)
      })
    },
    selectKecamatanByRole() {

      let profil = this.$store.getters.getUserProfile
      if (!this.profil) {
        this.$store.dispatch('fetchUserProfile').then(res => {
          profil = this.$store.getters.getUserProfile
          let id_kecamatan_user = profil.desa.id_kecamatan
          let selectedKecamatan = this.optionKecamatan.find(e => e.id_kecamatan === id_kecamatan_user)

          this.filter.id_kecamatan = selectedKecamatan
        })
      } else {
        let id_kecamatan_user = profil.desa.id_kecamatan
        let selectedKecamatan = this.optionKecamatan.find(e => e.id_kecamatan === id_kecamatan_user)

        this.filter.id_kecamatan = selectedKecamatan
      }

    },
    loadDesa() {
      this.loadingDesa = true
      this.$store.dispatch('fetchDesa', { id_kecamatan: this.filter.id_kecamatan.id_kecamatan }).then(res => {
        if (res.data.status) {
          let optDes = []
          optDes.push({
            id_desa: 0,
            nama_desa: 'SEMUA DESA'
          })
          res.data.data.forEach(e => {
            optDes.push(e)
          })
          this.optionDesa = optDes

          if (
            this.$store.getters.getAuthService.currentRole.nama_role === 'Operator Desa' ||
            this.$store.getters.getAuthService.currentRole.nama_role === 'Kepala Desa'
          ) {
            this.selectDesaByRole()
          }

          this.loadingDesa = false
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      }).catch(err => {
        // console.log(err)
      })
    },
    loadDesaModal() {
      // ini di widget desa di modal tambah akun
      this.loadingDesaModal = true
      this.$store.dispatch('fetchDesa', { id_kecamatan: this.formAkun.id_kecamatan.id_kecamatan }).then(res => {
        if (res.data.status) {
          let optDes = []
          optDes.push({
            id_desa: 0,
            nama_desa: 'SEMUA DESA'
          })
          res.data.data.forEach(e => {
            optDes.push(e)
          })
          this.optionDesaModal = optDes

          this.loadingDesaModal = false
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      }).catch(err => {
        // console.log(err)
      })
    },
    selectDesaByRole() {
      let profil = this.$store.getters.getUserProfile
      if (!this.profil) {
        this.$store.dispatch('fetchUserProfile').then(res => {
          profil = this.$store.getters.getUserProfile
          let id_desa_user = profil.id_desa
          let selectedDesa = this.optionDesa.find(e => e.id_desa === id_desa_user)

          this.filter.id_desa = selectedDesa
        })
      } else {
        let id_desa_user = profil.id_desa
        let selectedDesa = this.optionDesa.find(e => e.id_desa === id_desa_user)

        this.filter.id_desa = selectedDesa
      }
    },
    setDefaultFilterPengguna() {
      if (this.namaRole === 'Operator Desa') {
        this.filter.role = 'Penduduk'
      }
    }
  },
  mounted() {
    //MAKA AKAN MENJALANKAN FUNGSI BERIKUT
    this.loadPostsData()

    this.loadKecamatan()

  },
  watch: {
    'filter.id_kecamatan'(newVal) {
      this.loadDesa()
    },
    'formAkun.id_kecamatan': function (newVal) {
      this.loadDesaModal()
    }

  }
}
</script>

<style>

</style>
